import React, {Component} from 'react';
import cnames from 'classnames';
import PropTypes from 'prop-types';
import DestinationTypeahead from '@homeaway/react-destination-typeahead';
import './style.less';

export default class Typeahead extends Component {
    static propTypes = {
        query: PropTypes.string,
        onInputQuery: PropTypes.func.isRequired,
        locale: PropTypes.string,
        labels: PropTypes.shape({}),
        typeaheadProps: PropTypes.shape({}),
        isTypeaheadInputFocus: PropTypes.bool,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        splitDatePicker: PropTypes.bool
    };

    static defaultProps = {
        query: ''
    };

    handleSearchSelected = (result) => {
        this.props.onInputQuery(result);
    };

    render() {
        const {query, locale, typeaheadProps, isTypeaheadInputFocus, onBlur, onFocus, splitDatePicker} = this.props;
        const className = cnames('typeahead__container', {
            'typeahead__container--split-dates': splitDatePicker
        });

        return (
            <div className={className}>
                <DestinationTypeahead
                    search={query}
                    defaultSearch={query}
                    onSearchSelected={this.handleSearchSelected}
                    messages={this.props.labels}
                    {...{onBlur, onFocus, locale, isTypeaheadInputFocus}}
                    {...typeaheadProps}
                />
            </div>
        );
    }
}
